export default __webpack_public_path__ + "static/media/bauernhof.62828176.png";